export const slateMeta = {
  'de254c5d-57a7-4553-850f-153ee385014d': {
    id: 'de254c5d-57a7-4553-850f-153ee385014d',
    displayName: 'Must-read stories',
    description: 'Compelling articles worth your time'
  },
  '2389f563-bd42-411d-bca2-0966638053e8': {
    id: '2389f563-bd42-411d-bca2-0966638053e8',
    displayName: 'Pocket worthy',
    description: 'Fascinating stories to fill your Pocket with'
  },
  '2e3ddc90-8def-46d7-b85f-da7525c66fb1': {
    id: '2e3ddc90-8def-46d7-b85f-da7525c66fb1',
    displayName: 'Editors’ picks',
    description: 'Great reads from around the web, curated by Pocket'
  },
  '48e766be-5e96-46fb-acbf-55fee3ae8a28': {
    id: '48e766be-5e96-46fb-acbf-55fee3ae8a28',
    displayName: 'Spotlight',
    description: 'Essential articles to save to your Pocket'
  },
  '0737b00e-a21e-4875-a4c7-3e14926d4acf': {
    id: '0737b00e-a21e-4875-a4c7-3e14926d4acf',
    displayName: 'Best of the web',
    description: 'New perspectives, intriguing deep-dives, and timeless classics'
  },
  '631d8077-1462-4397-ad0a-aa340c27570a': {
    id: '631d8077-1462-4397-ad0a-aa340c27570a',
    displayName: 'Editors’ Picks, just for you',
    description: 'Stories to fuel your mind, curated for your interests'
  },
  'ad73c061-5ac5-458f-8691-ab071f7eadd7': {
    id: 'ad73c061-5ac5-458f-8691-ab071f7eadd7',
    displayName: 'Popular Pocket picks, curated for you',
    description: 'Thought-provoking stories and hidden gems that feed your interests'
  },
  'd9c6ddfa-a58d-402d-9664-4190ba197ea6': {
    id: 'd9c6ddfa-a58d-402d-9664-4190ba197ea6',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Business Slate',
    curatorTopicLabel: 'Business',
    slug: 'business',
    type: 'topic'
  },
  '505c0126-d54d-42ef-8fe7-0f6a6f24e3a5': {
    id: '505c0126-d54d-42ef-8fe7-0f6a6f24e3a5',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Business Slate',
    curatorTopicLabel: 'Business',
    slug: 'business',
    type: 'topic'
  },
  'af2cc2c0-1286-47a3-b8ce-187b905f94af': {
    id: 'af2cc2c0-1286-47a3-b8ce-187b905f94af',
    displayName: 'Business',
    description: 'Curated Not New Tab Business Slate',
    curatorTopicLabel: 'Business',
    slug: 'business',
    type: 'topic'
  },
  'e6c8db8d-cae7-4947-a57e-872dec639472': {
    id: 'e6c8db8d-cae7-4947-a57e-872dec639472',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Career Slate',
    curatorTopicLabel: 'Career',
    slug: 'career',
    type: 'topic'
  },
  'b4032752-155b-4f09-ac1e-f5337df19e88': {
    id: 'b4032752-155b-4f09-ac1e-f5337df19e88',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Career Slate',
    curatorTopicLabel: 'Career',
    slug: 'career',
    type: 'topic'
  },
  '00f0c593-3c99-4d5a-9297-c66f8b00be01': {
    id: '00f0c593-3c99-4d5a-9297-c66f8b00be01',
    displayName: 'Career',
    description: 'Curated Not New Tab Career Slate',
    curatorTopicLabel: 'Career',
    slug: 'career',
    type: 'topic'
  },
  '8aaac382-9c27-42ab-9470-ac1dfc666262': {
    id: '8aaac382-9c27-42ab-9470-ac1dfc666262',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Education Slate',
    curatorTopicLabel: 'Education',
    slug: 'education',
    type: 'topic'
  },
  'b0de37c0-81ef-4063-a432-1bb64270b039': {
    id: 'b0de37c0-81ef-4063-a432-1bb64270b039',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Education Slate',
    curatorTopicLabel: 'Education',
    slug: 'education',
    type: 'topic'
  },
  '856eb5f8-da7f-43ae-ac5e-25da402af0ae': {
    id: '856eb5f8-da7f-43ae-ac5e-25da402af0ae',
    displayName: 'Education',
    description: 'Curated Not New Tab Education Slate',
    curatorTopicLabel: 'Education',
    slug: 'education',
    type: 'topic'
  },
  'ce96db55-f32e-48f1-929f-216eb2e8c082': {
    id: 'ce96db55-f32e-48f1-929f-216eb2e8c082',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Entertainment Slate',
    curatorTopicLabel: 'Entertainment',
    slug: 'entertainment',
    type: 'topic'
  },
  'e9df8a81-19af-48e2-a90f-05e9a37491ca': {
    id: 'e9df8a81-19af-48e2-a90f-05e9a37491ca',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Entertainment Slate',
    curatorTopicLabel: 'Entertainment',
    slug: 'entertainment',
    type: 'topic'
  },
  'cceefa28-906e-47c5-b704-8c5b824ecd1b': {
    id: 'cceefa28-906e-47c5-b704-8c5b824ecd1b',
    displayName: 'Entertainment',
    description: 'Curated Not New Tab Entertainment Slate',
    curatorTopicLabel: 'Entertainment',
    slug: 'entertainment',
    type: 'topic'
  },
  '884414d5-502d-4e1a-8e70-1dc8eb4a345a': {
    id: '884414d5-502d-4e1a-8e70-1dc8eb4a345a',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Food Slate',
    curatorTopicLabel: 'Food',
    slug: 'food',
    type: 'topic'
  },
  '1a634351-361b-4115-a9d5-b79131b1f95a': {
    id: '1a634351-361b-4115-a9d5-b79131b1f95a',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Food Slate',
    curatorTopicLabel: 'Food',
    slug: 'food',
    type: 'topic'
  },
  '651d27ab-a898-4173-9700-dd1726fbaaa4': {
    id: '651d27ab-a898-4173-9700-dd1726fbaaa4',
    displayName: 'Food',
    description: 'Curated Not New Tab Food Slate',
    curatorTopicLabel: 'Food',
    slug: 'food',
    type: 'topic'
  },

  '44dff273-3604-40e9-a0b5-bf3852581990': {
    id: '44dff273-3604-40e9-a0b5-bf3852581990',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Gaming Slate',
    curatorTopicLabel: 'Gaming',
    slug: 'gaming',
    type: 'topic'
  },
  '4cc738f7-25a9-4511-9cc3-68a8f9be91f8': {
    id: '4cc738f7-25a9-4511-9cc3-68a8f9be91f8',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Gaming Slate',
    curatorTopicLabel: 'Gaming',
    slug: 'gaming',
    type: 'topic'
  },
  '951ae6c3-4438-458b-9936-7f3b8ff0f178': {
    id: '951ae6c3-4438-458b-9936-7f3b8ff0f178',
    displayName: 'Gaming',
    description: 'Curated Not New Tab Gaming Slate',
    curatorTopicLabel: 'Gaming',
    slug: 'gaming',
    type: 'topic'
  },
  '494eaa68-f048-4f52-bb9a-5e7d2526f5cb': {
    id: '494eaa68-f048-4f52-bb9a-5e7d2526f5cb',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Health Slate',
    curatorTopicLabel: 'Health & Fitness',
    slug: 'health',
    type: 'topic'
  },
  '7cb4f497-fd05-42c5-9f78-3650e9ddba21': {
    id: '7cb4f497-fd05-42c5-9f78-3650e9ddba21',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Health Slate',
    curatorTopicLabel: 'Health & Fitness',
    slug: 'health',
    type: 'topic'
  },
  '47023d21-0aa6-4f98-9077-eac21fad44f1': {
    id: '47023d21-0aa6-4f98-9077-eac21fad44f1',
    displayName: 'Health & Fitness',
    description: 'Curated Not New Tab Health Slate',
    curatorTopicLabel: 'Health & Fitness',
    slug: 'health',
    type: 'topic'
  },
  'e6600ffe-b65a-42d3-b570-f460f3d7326e': {
    id: 'e6600ffe-b65a-42d3-b570-f460f3d7326e',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Parenting Slate',
    curatorTopicLabel: 'Parenting',
    slug: 'parenting',
    type: 'topic'
  },
  '90adee1c-7794-4f41-9645-2ff9cf91113c': {
    id: '90adee1c-7794-4f41-9645-2ff9cf91113c',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Parenting Slate',
    curatorTopicLabel: 'Parenting',
    slug: 'parenting',
    type: 'topic'
  },
  '1a8de2be-db03-4a2f-901a-7c4c1cbd156a': {
    id: '1a8de2be-db03-4a2f-901a-7c4c1cbd156a',
    displayName: 'Parenting',
    description: 'Curated Not New Tab Parenting Slate',
    curatorTopicLabel: 'Parenting',
    slug: 'parenting',
    type: 'topic'
  },
  '72ce0827-9dbc-470f-9722-39476daaeb0f': {
    id: '72ce0827-9dbc-470f-9722-39476daaeb0f',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Personal Finance Slate',
    curatorTopicLabel: 'Personal Finance',
    slug: 'personal-finance',
    type: 'topic'
  },
  '0c09627b-a409-4768-b87d-7e1d29259785': {
    id: '0c09627b-a409-4768-b87d-7e1d29259785',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Personal Finance Slate',
    curatorTopicLabel: 'Personal Finance',
    slug: 'personal-finance',
    type: 'topic'
  },
  'e8251442-ef97-422f-ad65-0f28e6f7a0d6': {
    id: 'e8251442-ef97-422f-ad65-0f28e6f7a0d6',
    displayName:
      'QA slate duplicated from 0c09627b-a409-4768-b87d-7e1d29259785, that is only used for QA purposes',
    description: 'Curated Personal Finance Slate',
    curatorTopicLabel: 'Personal Finance',
    slug: 'personal-finance',
    type: 'topic'
  },
  'f4b58337-4ab6-4563-9503-c384e773946f': {
    id: 'f4b58337-4ab6-4563-9503-c384e773946f',
    displayName: 'Personal Finance',
    description: 'Curated Not New Tab Personal Finance Slate',
    curatorTopicLabel: 'Personal Finance',
    slug: 'personal-finance',
    type: 'topic'
  },
  '9901851d-ea76-4667-8dc7-0c1677ecb910': {
    id: '9901851d-ea76-4667-8dc7-0c1677ecb910',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Politics Slate',
    curatorTopicLabel: 'Politics',
    slug: 'politics',
    type: 'topic'
  },
  '9bece73b-4d54-43a6-bb10-d7b02abcd181': {
    id: '9bece73b-4d54-43a6-bb10-d7b02abcd181',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Politics Slate',
    curatorTopicLabel: 'Politics',
    slug: 'politics',
    type: 'topic'
  },
  'f8c945b0-52fa-4203-bb31-6747245fe021': {
    id: 'f8c945b0-52fa-4203-bb31-6747245fe021',
    displayName: 'Politics',
    description: 'Curated Not New Tab Politics Slate',
    curatorTopicLabel: 'Politics',
    slug: 'politics',
    type: 'topic'
  },
  'ab6048ca-5c61-4e87-aefd-7a612b60ab7b': {
    id: 'ab6048ca-5c61-4e87-aefd-7a612b60ab7b',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Science Slate',
    curatorTopicLabel: 'Science',
    slug: 'science',
    type: 'topic'
  },
  'b64c873e-7f05-496e-8be4-bfae929c8a04': {
    id: 'b64c873e-7f05-496e-8be4-bfae929c8a04',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Science Slate',
    curatorTopicLabel: 'Science',
    slug: 'science',
    type: 'topic'
  },
  'b548b456-70c4-474d-a723-80d040d00fec': {
    id: 'b548b456-70c4-474d-a723-80d040d00fec',
    displayName: 'Science',
    description: 'Curated Not New Tab Science Slate',
    curatorTopicLabel: 'Science',
    slug: 'science',
    type: 'topic'
  },
  '47688fcf-2bbb-4e0e-a02e-1f68c248a67e': {
    id: '47688fcf-2bbb-4e0e-a02e-1f68c248a67e',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Self-Improvement Slate',
    curatorTopicLabel: 'Self Improvement',
    slug: 'self-improvement',
    type: 'topic'
  },
  '6d1273a5-055e-4de0-8a5b-5f2b79d37e5c': {
    id: '6d1273a5-055e-4de0-8a5b-5f2b79d37e5c',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Self-Improvement Slate',
    curatorTopicLabel: 'Self Improvement',
    slug: 'self-improvement',
    type: 'topic'
  },
  '5674f085-07b6-43c3-bcde-2774db3f6384': {
    id: '5674f085-07b6-43c3-bcde-2774db3f6384',
    displayName: 'Self Improvement',
    description: 'Curated Not New Tab Self Improvement Slate',
    curatorTopicLabel: 'Self Improvement',
    slug: 'self-improvement',
    type: 'topic'
  },
  '8a495385-9972-4d0e-b93e-4234f4897939': {
    id: '8a495385-9972-4d0e-b93e-4234f4897939',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Sports Slate',
    curatorTopicLabel: 'Sports',
    slug: 'sports',
    type: 'topic'
  },
  'ea40bef5-4406-488d-ad9d-915dfa1f0794': {
    id: 'ea40bef5-4406-488d-ad9d-915dfa1f0794',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Sports Slate',
    curatorTopicLabel: 'Sports',
    slug: 'sports',
    type: 'topic'
  },
  'e6c00454-4a00-47c1-8f22-906122c261ed': {
    id: 'e6c00454-4a00-47c1-8f22-906122c261ed',
    displayName: 'Sports',
    description: 'Curated Not New Tab Sports Slate',
    curatorTopicLabel: 'Sports',
    slug: 'sports',
    type: 'topic'
  },
  'fa61096a-b681-4251-b299-2fda06c49ebf': {
    id: 'fa61096a-b681-4251-b299-2fda06c49ebf',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Technology Slate',
    curatorTopicLabel: 'Technology',
    slug: 'technology',
    type: 'topic'
  },
  'e0d7063a-9421-4148-b548-446e9fbc8566': {
    id: 'e0d7063a-9421-4148-b548-446e9fbc8566',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Technology Slate',
    curatorTopicLabel: 'Technology',
    slug: 'technology',
    type: 'topic'
  },
  'ed9604ce-b752-48bd-b8c5-3a8cf6b54ced': {
    id: 'ed9604ce-b752-48bd-b8c5-3a8cf6b54ced',
    displayName: 'Technology',
    description: 'Curated Not New Tab Technology Slate',
    curatorTopicLabel: 'Technology',
    slug: 'technology',
    type: 'topic'
  },
  'd024ce9c-ed96-453f-a81e-8a0b850681e7': {
    id: 'd024ce9c-ed96-453f-a81e-8a0b850681e7',
    displayName: 'Popular with Pocket readers  Stories from across the web',
    description: 'Algorithmic Travel Slate',
    curatorTopicLabel: 'Travel',
    slug: 'travel',
    type: 'topic'
  },
  '9389d944-fdcf-4394-9ca3-4604c0af4fac': {
    id: '9389d944-fdcf-4394-9ca3-4604c0af4fac',
    displayName: 'Curated by our editors Stories to fuel your mind',
    description: 'Curated Travel Slate',
    curatorTopicLabel: 'Travel',
    slug: 'travel',
    type: 'topic'
  },
  '4345efa7-2c89-4884-b836-3260757a3a97': {
    id: '4345efa7-2c89-4884-b836-3260757a3a97',
    displayName: 'Travel',
    description: 'Curated Not New Tab Travel Slate',
    curatorTopicLabel: 'Travel',
    slug: 'travel',
    type: 'topic'
  },
  '796ca16f-4cd4-4dcb-84d5-477715c41668': {
    id: '796ca16f-4cd4-4dcb-84d5-477715c41668',
    displayName: 'Stay informed with this curated guide to the global outbreak.',
    description: 'Coronavirus Slate',
    curatorTopicLabel: 'COVID-19',
    slug: 'coronavirus',
    type: 'topic'
  },
  '0f322865-64e6-472d-8147-b3d6637a7d67': {
    id: '0f322865-64e6-472d-8147-b3d6637a7d67',
    displayName: 'Our most-read Collections',
    description: 'Pocket Collections',
    type: 'collection'
  },
  '4d95bade-8a43-4700-9879-3a73ba1da640': {
    id: '4d95bade-8a43-4700-9879-3a73ba1da640',
    displayName: 'Incredible long reads that’ll transport you to another time and place',
    description: 'Dive into another world with these fascinating stories.'
  },
  '8944f662-cfc7-4fcb-a510-55a8589b08e7': {
    id: '8944f662-cfc7-4fcb-a510-55a8589b08e7',
    displayName: 'How to start cooking',
    description: 'Get comfortable in the kitchen with beginner-friendly tips and techniques.'
  },
  '626397d3-fa4e-4299-8d07-cbeaa269ebc1': {
    id: '626397d3-fa4e-4299-8d07-cbeaa269ebc1',
    displayName: 'Ten minutes or less',
    description: 'Smart, quick reads from trusted sources'
  },
  '8fa462a6-81d1-47ee-8de3-1e5e0030e6d6': {
    id: '8fa462a6-81d1-47ee-8de3-1e5e0030e6d6',
    displayName: 'Long reads worth the time',
    description: 'The best longform journalism and essays popular in Pocket'
  },
  '2f2a3568-901f-4655-8735-daf67e8ecc5d': {
    id: '2f2a3568-901f-4655-8735-daf67e8ecc5d',
    displayName: 'In case you missed it',
    description: 'Great stories that stand the test of time'
  }
}
